/**
 * @generated SignedSource<<9a730feeed445181e402b2ebe3bc3387>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type SingleUnitGetTargetQuery$variables = {
  targetGroupIsActive?: ActiveRecords | null | undefined;
  targetId: string;
};
export type SingleUnitGetTargetQuery$data = {
  readonly target: {
    readonly id: string;
    readonly isActive: boolean;
    readonly name: string | null | undefined;
    readonly summary: string | null | undefined;
    readonly targetGroup: {
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly targetSkills: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
      readonly skill: {
        readonly code: string | null | undefined;
        readonly difficulty: any;
        readonly id: string;
        readonly lessons: ReadonlyArray<{
          readonly id: string;
        } | null | undefined> | null | undefined;
        readonly name: string | null | undefined;
        readonly skillAncestries: ReadonlyArray<{
          readonly ancestorSkill: {
            readonly code: string | null | undefined;
            readonly difficulty: any;
            readonly id: string;
            readonly name: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly skillRelevance: {
            readonly id: string;
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly standards: ReadonlyArray<{
          readonly id: string;
          readonly shortName: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly targetSkillType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SingleUnitGetTargetQuery = {
  response: SingleUnitGetTargetQuery$data;
  variables: SingleUnitGetTargetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": "BOTH",
  "kind": "LocalArgument",
  "name": "targetGroupIsActive"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetId"
},
v2 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "isActive": "ACTIVE"
    }
  },
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "isActive",
        "variableName": "targetGroupIsActive"
      }
    ],
    "kind": "ObjectValue",
    "name": "targetGroupFilter"
  },
  {
    "kind": "Variable",
    "name": "targetId",
    "variableName": "targetId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "summary",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v7 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "TargetSkillNode",
  "kind": "LinkedField",
  "name": "targetSkills",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TargetSkillTypeNode",
      "kind": "LinkedField",
      "name": "targetSkillType",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillNode",
      "kind": "LinkedField",
      "name": "skill",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        (v4/*: any*/),
        (v8/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "isActive": true,
                "lessonTypeIds": [
                  "LessonTypeNode:11"
                ]
              }
            }
          ],
          "concreteType": "LessonSkillNode",
          "kind": "LinkedField",
          "name": "lessons",
          "plural": true,
          "selections": [
            (v3/*: any*/)
          ],
          "storageKey": "lessons(filter:{\"isActive\":true,\"lessonTypeIds\":[\"LessonTypeNode:11\"]})"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StandardNode",
          "kind": "LinkedField",
          "name": "standards",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "shortName",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillAncestryNode",
          "kind": "LinkedField",
          "name": "skillAncestries",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillNode",
              "kind": "LinkedField",
              "name": "ancestorSkill",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                (v4/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillRelevanceNode",
              "kind": "LinkedField",
              "name": "skillRelevance",
              "plural": false,
              "selections": (v7/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SingleUnitGetTargetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TargetNode",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SingleUnitGetTargetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "TargetNode",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetGroupNode",
            "kind": "LinkedField",
            "name": "targetGroup",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8f9085f1ebe6eb2602be467cb49302da",
    "id": null,
    "metadata": {},
    "name": "SingleUnitGetTargetQuery",
    "operationKind": "query",
    "text": "query SingleUnitGetTargetQuery(\n  $targetId: ID!\n  $targetGroupIsActive: ActiveRecords = BOTH\n) {\n  target(targetId: $targetId, filter: {isActive: ACTIVE}, targetGroupFilter: {isActive: $targetGroupIsActive}) {\n    id\n    name\n    summary\n    isActive\n    targetGroup {\n      name\n      id\n    }\n    targetSkills {\n      id\n      isActive\n      targetSkillType {\n        id\n        name\n      }\n      skill {\n        id\n        name\n        code\n        difficulty\n        lessons(filter: {lessonTypeIds: [\"LessonTypeNode:11\"], isActive: true}) {\n          id\n        }\n        standards {\n          id\n          shortName\n        }\n        skillAncestries {\n          id\n          ancestorSkill {\n            id\n            name\n            code\n            difficulty\n          }\n          skillRelevance {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec751e48725807e564b1bdd91d33e245";

export default node;
